import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../../atoms/Icon';

var AppConfig = require('../../../config.json');

/**
 * A simple OrderFormPrivacyCheckbox.
 */

class OrderFormPrivacyCheckbox extends React.Component {
	constructor(props) {
	  super(props);
		this.handleClick = this.handleClick.bind(this);
	  this.state = {active:false, init:false};
	}
	componentDidMount() {
		if(this.props.privacy.checkbox) {
			this.setState({active:true});
		}
		this.setState({init:true});
	}


	handleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(nextState);
	}

    render () {
        return (
          <div className={`orderformprivacycheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className="desc" onClick={this.handleClick}>
	            	<div className="subline bold" style={{color:"black"}}>
					Ich habe die <a href={AppConfig.legalCheckboxLinks.datenschutz} target="_blank" rel="noopener noreferrer">Datenschutzbestimmungen</a> zur Kenntnis genommen.
	              	</div>
            	</div>
            </div>
            
          </div>
        );
    }

}

OrderFormPrivacyCheckbox.propTypes = {
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func
}

OrderFormPrivacyCheckbox.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a OrderFormPrivacyCheckbox Component!', event.target);
	}
	
}


const mapStateToProps = (state) => {
  return {
    privacy: state.status.privacy
  }
}


export default connect(
  mapStateToProps,
  null
)(OrderFormPrivacyCheckbox)







// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormPrivacyCheckbox/OrderFormPrivacyCheckbox.js